import { useMemo } from "react";
import type { ISEOProps, IResolvedPageSEO, TPageSEOKey } from "./types/core";
import { generateSEO } from "./seo";

export default function useSEO(
  page: TPageSEOKey,
  seoData?: Partial<ISEOProps>
): IResolvedPageSEO {
  const seo = useMemo(() => {
    return generateSEO(page, seoData);
  }, [page, seoData]);

  return {
    ...seo,
  };
}
